import React, {Component} from "react";
import {Link} from "react-router-dom";
import {generate} from "../../../../routes.js";

import '../Level2Menu.scss'
import './AdministrationMenu.scss'

class AdministrationMenu extends Component {

  render() {
    const {isAdmin, link} = this.props

    return (
      <div className={`level2-menu admininstration-menu`}>
        <div className="level2-menu-title">
          <span>Administration</span>
        </div>

        <ul className={`level2-menu-list`}>
          {isAdmin ?
            <li className="level2-menu-list-item">
              <Link
                className="d-flex align-items-center flex-nowrap"
                to={generate({
                  name: `${link.menu}.review`,
                  parameters: link.parameters,
                  search: link.search
                })}
              >
                Notation
              </Link></li> : null
          }
          <li className="level2-menu-list-item">
            <Link
              className="d-flex align-items-center flex-nowrap"
              to={generate({
                name: `${link.menu}.monitor`,
                parameters: link.parameters,
                search: link.search
              })}
            >
              Suivi
            </Link>
          </li>
          <li className="level2-menu-list-item">
            <Link
              className="d-flex align-items-center flex-nowrap"
              to={generate({
                name: `${link.menu}.positionings-and-progessi-missions`,
                parameters: link.parameters,
                search: link.search
              })}
            >
              Positionnements & Missions
            </Link>
          </li>
          <li className="level2-menu-list-item">
            <Link
              className="d-flex align-items-center flex-nowrap"
              to={generate({
                name: `${link.menu}.history`,
                parameters: link.parameters,
                search: link.search
              })}
            >
              Historique
            </Link>
          </li>
          <li className="level2-menu-list-item">
            <Link
              className="d-flex align-items-center flex-nowrap"
              to={generate({
                name: `${link.menu}.skills`,
                parameters: link.parameters,
                search: link.search
              })}
            >
              Compétences
            </Link>
          </li>
        </ul>
      </div>
    )
  }
}

export default AdministrationMenu